import graphqlHelperService from "./graphqlHelper.service";
import { Issuer } from "../types/payment";

export const PaymentService = {
    issuersList: async (): Promise<Issuer[]> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            issuersListQuery()
        );
        return apolloResult.getIssuerList as Issuer[];
    },
    invoiceLink: async (invoiceId: string, description: string, issuerId: string | undefined, returnUrl: string): Promise<string> => {
        const apolloResult = await graphqlHelperService.sendQuery(
            invoiceLinkQuery,
            {
                paymentInput: {
                    paymentId: invoiceId,
                    description,
                    issuerId: issuerId ? issuerId : "",
                    returnUrl,
                }
            }
        );
        return apolloResult.generateInvoiceIdealLink as string;
    },
    paymentReturned: async (transactionId: string): Promise<void> => {
        await graphqlHelperService.sendMutate(
            paymentReturnedMutation(transactionId)
        );
        return;
    }
}

const invoiceLinkQuery = `query GenerateInvoiceIdealLink($paymentInput: Paymentinput!) {
    generateInvoiceIdealLink(
        paymentInput: $paymentInput
    )
}`

const issuersListQuery = () => `query {
    getIssuerList {
        issuerId
        issuerName
    }
}`

const paymentReturnedMutation = (transactionId: string) => `mutation {
    paymentReturned(transactionId: "${transactionId}")
}`